import useAsyncData from "../../../hooks/use-async-data";
import gpsService from "../gps.service";
import GpsCargoOrderRecord from "./gps-cargo-order-records";
import GpsCargoOrderRecordsParams from "./gps-cargo-order-records-params";

const useGpsCargoOrderRecords = (defaultLoadingState?: boolean) => {
  const { data, isError, isLoading, setData, setIsError, setIsLoading } =
    useAsyncData<GpsCargoOrderRecord[]>([], defaultLoadingState);

  const load = async (
    params: GpsCargoOrderRecordsParams,
    abortSignal: AbortSignal,
  ) => {
    setIsError(false);
    setIsLoading(true);

    try {
      const data = await gpsService.getCargoOrderRecords(params, abortSignal);

      setData(data);
    } catch {
      setIsError(true);
    } finally {
      setIsLoading(false);
    }
  };

  return {
    data,
    isError,
    isLoading,
    load,
  };
};

export default useGpsCargoOrderRecords;
